module.exports = __webpack_public_path__ + "static/media/icons-hb-quality.2b2cd7e1.svg";